import * as Yup from "yup";

export const dataModel = {
  userUuid: "",
  roles: "",
  viveroUuid: "",
  active: false,
  create: false,
  name: "",
  surname1: "",
  surname2: "",
  email: "",
  nif: "",
};

export const validationDataModel = (edit, create) => {
  if (edit) {
    return Yup.object().shape({
      create: Yup.boolean().required("forms.validations.required"),
      userUuid: create
        ? Yup.string().notRequired()
        : Yup.string().required("forms.validations.required"),
      roles: Yup.array().required("forms.validations.required"),
      viveroUuid: Yup.string().required("forms.validations.required"),
      active: Yup.boolean().required("forms.validations.required"),
      name: create
        ? Yup.string().required("forms.validations.required")
        : Yup.string().notRequired(),
      surname1: create
        ? Yup.string().required("forms.validations.required")
        : Yup.string().notRequired(),
      surname2: Yup.string().notRequired(),
      email: create
        ? Yup.string()
            .email("forms.validations.formatEmail")
            .required("forms.validations.required")
        : Yup.string().notRequired(),
      nif: create
        ? Yup.string().required("forms.validations.required")
        : Yup.string().notRequired(),
    });
  }

  return Yup.object().shape({
    create: Yup.boolean().required("forms.validations.required"),
    userUuid: create
      ? Yup.string().notRequired()
      : Yup.string().required("forms.validations.required"),
    roles: Yup.array().required("forms.validations.required"),
    viveroUuid: Yup.string().required("forms.validations.required"),
    active: Yup.boolean().required("forms.validations.required"),
    name: create
      ? Yup.string().required("forms.validations.required")
      : Yup.string().notRequired(),
    surname1: create
      ? Yup.string().required("forms.validations.required")
      : Yup.string().notRequired(),
    surname2: Yup.string().notRequired(),
    email: create
      ? Yup.string()
          .email("forms.validations.formatEmail")
          .required("forms.validations.required")
      : Yup.string().notRequired(),
    nif: create
      ? Yup.string().required("forms.validations.required")
      : Yup.string().notRequired(),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
